<template>
  <div>
    <game-title text="Mega League" />
    <game-week-navigator @gameWeekUpdate="gameWeekUpdate($event)" />
    <mega-league-create
      v-if="gameWeek && gameWeek.isOpen()"
      :game-week="gameWeek"
    />
    <mega-league-read
      v-else-if="gameWeek && !gameWeek.isOpen()"
      :game-week="gameWeek"
    />
  </div>
</template>

<script>
import GameTitle from "@/components/GameTitle.vue";
import GameWeekNavigator from "@/components/GameWeek/GameWeekNavigator.vue";
import MegaLeagueCreate from "@/components/MegaLeague/MegaLeagueCreate.vue";
import MegaLeagueRead from "@/components/MegaLeague/MegaLeagueRead.vue";

export default {
  name: "MegaLeague",
  components: {
    GameTitle,
    GameWeekNavigator,
    MegaLeagueCreate,
    MegaLeagueRead,
  },
  data() {
    return {
      gameWeek: null,
    };
  },
  methods: {
    gameWeekUpdate(newGameWeek) {
      this.gameWeek = newGameWeek;
    },
  },
};
</script>
